import { ForumPage } from "components/ForumPage"
import { useTranslator } from "components/Translator"
import { ForumPostsList } from "domains/forum-post/ForumPostsList"
import { Markdown } from "components/Markdown"

export function ClubForumTagPage(props) {
  const translator = useTranslator()

  return (
    <ForumPage
      metrics={props.metrics}
      tag={props.tag}
      formSearch={props.formSearch}
      title={translator.trans(
        "club.forum.tag.title",
        { tag: props.tag.title },
        "pages",
      )}
      main={
        <div className={"space-y-8"}>
          <Markdown>{props.tag.content}</Markdown>
          <ForumPostsList
            posts={props.posts}
            pagination={props.pagination}
            emptyLabel={translator.trans("club.forum.tag.empty", null, "pages")}
          />
        </div>
      }
    />
  )
}
